import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import './loader.scss';

const leafCount = 20;

type Leaf = {
  id: number;
  left: number;
  duration: number;
  delay: number;
  size: number;
};

const Leaves = () => {
  const [leaves, setLeaves] = useState<Leaf[]>([]);

  useEffect(() => {
    const newLeaves = [];

    for (let i = 0; i < leafCount; i++) {
      newLeaves.push({
        id: i,
        left: Math.random() * 100, // vw
        duration: 5 + Math.random() * 5, // s
        delay: Math.random() * 5, // s
        size: 10 + Math.random() * 20, // px
      });
    }

    setLeaves(newLeaves);
  }, []);

  return (
    <>
      {leaves.map(({ id, left, duration, delay, size }) => (
        <div
          key={id}
          className="leaf"
          style={{
            left: `${left}vw`,
            width: size,
            height: size,
            animationDuration: `${duration}s`,
            animationDelay: `${delay}s`,
          }}
        />
      ))}
    </>
  );
};

export const Loader = () => {
  return (
    <div className="balalyk_loader_wrapper ">
      {/* <Leaves /> */}
      <Spin indicator={<LoadingOutlined className="!text-[64px]" spin />} />
    </div>
  );
};
